import { ColumnConfig, ColumnConfigOptions, ColumnText, ConditionalExtractor, DateFormatter, ExtractAndFormatExtractor, LodashExtractor, LodashSeriesEnricherMapper, LodashSeriesMapper, MappedValueFormatter, NumberFormatter, StoreNestedFilterExtractor, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';
import { DateUtil } from '@ddt-web/generic-utils';

import { MODEL_FAMILY_COLUMN_CONFIG } from './family-column.config';


export const FAMILY_OVERVIEW_CONFIG = new TabConfig(
	'overview',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(['familyOverview', 'familyPerformance'], ['familyOverview', 'familyPerformance'], 'familyOverview.models', (overview: any, data: any) => {

			return {
				...overview,
				...(data?.familyPerformance?.models?.find(model => model?.id === overview.id) ?? [])
			};
		}),
		null,
		[
			ColumnConfig.create({
				id: 'id',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'expenseRatio',
				extractor: new StoreNestedFilterExtractor(
					['familyOverview'],
					'characteristics',
					[{ propertyToCompare: 'name', comparedValue: 'expenseRatio', desiredValueExpression: 'total' }]
				),
				labelFormatter: new NumberFormatter(NumberFormatter.PERCENT)
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			ColumnConfig.create({
				id: 'ytdReturn',
				// extractor: new LodashExtractor('ytdReturn_gross', ''),
				extractor: new StoreNestedFilterExtractor(
					['familyPerformance'],
					'performance.exPostMetrics[0].metrics',
					[{ propertyToCompare: 'name', comparedValue: 'totalReturnYtd', desiredValueExpression: 'metricValue' }]
				),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 })
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			ColumnConfig.create({
				infoBubble: {
					key: '12M_TRAILING_YIELD_TOOLTIP',
					defaultText: '12M_TRAILING_YIELD_TOOLTIP',
					attributes: {}
				},
				id: '12mTrailingYield',
				extractor: new StoreNestedFilterExtractor(
					['familyOverview'],
					'characteristics',
					[{ propertyToCompare: 'name', comparedValue: 'twelveMonthTrailingYield', desiredValueExpression: 'total' }]
				),
				labelFormatter: new NumberFormatter(NumberFormatter.PERCENT)
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			ColumnConfig.create({
				id: 'estimatedRisk',
				extractor: new LodashExtractor('risk.total', ''),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 })
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: '1YrReturn',
				extractor: new StoreNestedFilterExtractor(
					['familyPerformance'],
					'performance.exPostMetrics[0].metrics',
					[{ propertyToCompare: 'name', comparedValue: 'annualizedReturn1Yr', desiredValueExpression: 'metricValue' }]
				),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 })
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			ColumnConfig.create({
				id: '5YrReturn',
				extractor: new StoreNestedFilterExtractor(
					['familyPerformance'],
					'performance.exPostMetrics[0].metrics',
					[{ propertyToCompare: 'name', comparedValue: 'annualizedReturn5Yr', desiredValueExpression: 'metricValue' }]
				),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 })
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			// TODO wdsdecom: Need confirmation
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'expenseRatioAsOfDate',
				extractor: new LodashExtractor('analysisDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'ytdReturnAsOfDate',
				extractor: new LodashExtractor('performance.exPostMetrics[0].interval.stopDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>),
			// TODO wdsdecom: Need confirmation
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'twelveMonthTrailingYieldAsOfDate',
				extractor: new LodashExtractor('analysisDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>),
			// TODO wdsdecom: Need confirmation
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'estimatedRiskAsOfDate',
				extractor: new LodashExtractor('analysisDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'oneYrReturnAsOfDate',
				extractor: new LodashExtractor('analysisDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('AS_OF', 'As of'),
				id: 'fiveYrReturnAsOfDate',
				extractor: new LodashExtractor('analysisDate', ''),
				labelFormatter: new DateFormatter(DateUtil.MODELS_US_DATE_FORMAT)
			} as ColumnConfigOptions<LodashExtractor>)
		],
		MODEL_FAMILY_COLUMN_CONFIG
	));

export const MODEL_LIST_CONFIG = new TabConfig(
	'model.list',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(['families'], ['families'], 'families.models', (portfolio: any, data: any) => {
			return {
				...portfolio, managementType: portfolio?.managementType || data?.families?.managementType,
				familyName: data?.families?.description,
				familyId: data?.families?.id,
				modelFamilyExternalName: data?.families?.modelExternalName
			};
		}),
		null,
		[
			ColumnConfig.create({
				id: 'portfolioId',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'dasPortfolioId',
				extractor: new LodashExtractor('portfolioId', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'description',
				extractor: new ConditionalExtractor(
					model => model.managementType === 'research',
					new ExtractAndFormatExtractor('description', '', (description) => '*' + description),
					new LodashExtractor('description', '')
				)
			} as ColumnConfigOptions<ConditionalExtractor>),
			ColumnConfig.create({
				id: 'objective',
				extractor: new LodashExtractor('objective', '')
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'riskProfile',
				label: new ColumnText('RISK_PROFILE', 'Risk Profile'),
				extractor: new LodashExtractor('riskProfile', ''),
				labelFormatter: new MappedValueFormatter({
					'conservative': 'Conservative',
					'moderate_conservative': 'Moderate Conservative',
					'moderate': 'Moderate',
					'moderate_aggressive': 'Moderate Aggressive',
					'aggressive': 'Aggressive',
					'moderate conservative': 'Moderate Conservative',
					'moderate aggressive': 'Moderate Aggressive'
				})
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'modelShortName',
				extractor: new ConditionalExtractor(
					model => model.managementType === 'research',
					new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
					new LodashExtractor('shortName', '')
				),
				visible: true
			} as ColumnConfigOptions<ConditionalExtractor>),
			ColumnConfig.create({
				id: 'familyName',
				extractor: new LodashExtractor('familyName', '')
			} as ColumnConfig<LodashExtractor>),
			ColumnConfig.create({
				id: 'dasModelOrder',
				extractor: new LodashExtractor('dasModelOrder', '')
			} as ColumnConfig<LodashExtractor>),
			ColumnConfig.create({
				id: 'familyId',
				extractor: new LodashExtractor('familyId', '')
			} as ColumnConfig<LodashExtractor>),
			ColumnConfig.create({
				id: 'modelExternalName',
				extractor: new LodashExtractor('modelExternalName', '')
			} as ColumnConfig<LodashExtractor>),
			ColumnConfig.create({
				id: 'modelFamilyExternalName',
				extractor: new LodashExtractor('modelFamilyExternalName', '')
			} as ColumnConfig<LodashExtractor>)
		],
		MODEL_FAMILY_COLUMN_CONFIG
	)
);

export const FAMILY_OVERVIEW_CUSTOM_NET_RETURN_CONFIG = new TabConfig(
	'overview.custom.net.return',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesMapper(['familyPerformance'], 'familyPerformance.models'),
		null,
		[
			ColumnConfig.create({
				id: 'id',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'customNetYearToDate',
				extractor: new StoreNestedFilterExtractor(
					['familyPerformance'],
					'performance.netExPostMetrics[0].metrics',
					[{ propertyToCompare: 'name', comparedValue: 'totalReturnYtd', desiredValueExpression: 'metricValue' }]
				),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 }),
				visible: true
			} as ColumnConfigOptions<StoreNestedFilterExtractor>)
		],
		MODEL_FAMILY_COLUMN_CONFIG
	));

